module.exports = __webpack_public_path__ + "80c4851b6b53f00f130c0356f7252ccc.svg";